import { CurationDTO, CurationItemDTO, CurationPayload } from '@/apis/repositories/types/curation';
import httpClient from '@/modules/client/axios';

const curationUrl = '/curation';

/** 큐레이션 목록 */
export function fetchCurationAPI(data: CurationPayload) {
  const url = curationUrl;

  return httpClient.get<CurationDTO[]>(url, { params: data });
}

/** 큐레이션 상세 */
export function fetchCurationDetailAPI(curationSeq: number) {
  const url = `${curationUrl}/${curationSeq}`;

  return httpClient.get<CurationDTO>(url);
}

/**
 * 도서 - 책소개 - 새로 나온 책(목록)
 * 성인 단행본 새로 나온책 목록
 */
export function fetchCurationBookNewestAPI() {
  const url = `${curationUrl}/book-newest`;

  return httpClient.get<CurationItemDTO[]>(url);
}

/** 키즈 도서 새로 나온 책 */
export function fetchCurationKidsBookNewestAPI() {
  const url = `${curationUrl}/kids-book-newest`;

  return httpClient.get<CurationItemDTO[]>(url);
}
